var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-5 custom-height"},[_c('div',{staticClass:"w-100 d-flex text-group"},[_c('span',{staticClass:"text-center text-item"},[_vm._v("Selected Indicator has only National Data ")])])])
}]

export { render, staticRenderFns }